import { render, staticRenderFns } from "./taskContentConf.vue?vue&type=template&id=59ed68c0&scoped=true"
import script from "./taskContentConf.vue?vue&type=script&lang=js"
export * from "./taskContentConf.vue?vue&type=script&lang=js"
import style0 from "./taskContentConf.vue?vue&type=style&index=0&id=59ed68c0&prod&lang=css"
import style1 from "./taskContentConf.vue?vue&type=style&index=1&id=59ed68c0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ed68c0",
  null
  
)

export default component.exports